module.exports = __webpack_public_path__ + "img/allergy-soy.a2f81a3e.png";